<script setup lang="ts">
import ResultsWithinMinutes from "~/components/static/ResultsWithinMinutes.vue";
const locale = await getLocale("ui", "selected_amount", "it", true);

const props = defineProps({
    value: { type: Number, required: true },
    customClass: { type: String, required: false },
});

function composedTitle(str: string, value: string | number) {
    const splitIndex = str.indexOf('%d');

    if (splitIndex === -1) {
        return [str, '', ''];
    }

    const stringStart = str.substring(0, splitIndex);
    const stringValue = value?.toLocaleString("it-IT");
    const stringEnd = str.substring(splitIndex + 2);

    return `${stringStart}<span class="font-semibold">${stringValue}${stringEnd}</span>`;
}

const formattedTitle = computed(() => composedTitle(locale.title, props.value));

</script>

<template>
    <div class="bg-yellow text-center lg:text-left mt-4 flex flex-wrap lg:flex-no-wrap items-center py-2 px-2 md:px-12">
        <h1 class="text-center lg:text-left text-2xl md:text-3xl text-gray-700 leading-tight flex-1"
            :class="customClass">
            <span v-if="$slots.header">
                <slot name="header" />
            </span>
            <span v-else v-html="formattedTitle">
            </span>
        </h1>
        <div class="hidden sm:flex w-full sm:w-auto justify-center ml-auto mt-2 sm:mt-0">
            <ResultsWithinMinutes />
        </div>
    </div>
</template>

<style scoped></style>
